import { useEffect, useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { InputText, InputTextArea, SelectField } from "../../components";
import { connect, useDispatch } from "react-redux";
import { RootState } from "../../store/root-reducer";
import { fetchOptions } from "../../store/add-warrnty-item/actions";
function LineItem({ options }) {
  const { control } = useFormContext();
  const dispatch = useDispatch();

  const {
    itemTypeOptions,
    materialOptions,
    colorOptions,
    manufacturersOptions,
  } = useMemo(() => {
    const {
      claimItemTypes = [],
      colors = [],
      materialTypes = [],
      manufacturers = [],
    } = options;
    const itemTypeOptions = claimItemTypes?.map((v) => ({
      label: v.name,
      value: v.id,
    }));
    const materialOptions = materialTypes.map((v) => ({
      label: v.name,
      value: v.id,
    }));
    const colorOptions = colors.map((v) => ({
      label: v.name,
      value: v.id,
    }));
    const manufacturersOptions = manufacturers.map((v) => ({
      label: v.name,
      value: v.id,
    }));
    return {
      itemTypeOptions,
      materialOptions,
      colorOptions,
      manufacturersOptions,
    };
  }, [options]);

  useEffect(() => {
    if (
      itemTypeOptions.length === 0 ||
      materialOptions.length === 0 ||
      colorOptions.length === 0 ||
      manufacturersOptions.length === 0
    ) {
      dispatch(fetchOptions());
    }
    return () => {};
  }, [
    dispatch,
    colorOptions,
    itemTypeOptions,
    manufacturersOptions,
    materialOptions,
  ]);

  return (
    <div className="space-y-2">
      <SelectField
        required
        label="Item Type"
        control={control}
        placeholder="Select Item Type"
        name="itemType"
        options={itemTypeOptions}
      />
      <SelectField
        label="manufacturer"
        control={control}
        placeholder="Select Manufacture"
        name="manuFacturer"
        required
        options={manufacturersOptions}
      />
      <InputText
        name="vendor"
        placeholder="Vendor"
        label="Vendor"
        control={control}
      />
      <SelectField
        required
        label="Material"
        control={control}
        placeholder="Select Material"
        name="material"
        options={materialOptions}
      />
      <SelectField
        required
        label="Color"
        control={control}
        placeholder="Select Color"
        name="color"
        options={colorOptions}
      />
      <InputText name="sku" placeholder="SKU" label="SKU" control={control} />
      <InputText
        name="model"
        placeholder="Model"
        label="Model"
        control={control}
        required
      />
      <InputText
        name="price"
        placeholder="Price"
        label="Price"
        control={control}
        required
        type="number"
        inputProps={{ min: "0", step: "any" }}
      />
      <InputText
        required
        name="quantity"
        placeholder="Quantity"
        label="Quantity"
        control={control}
        type="number"
        rules={{
          min: { value: 1, message: "Please enter at least 1 quantity." },
          max: {
            value: 10,
            message: "You can only enter up to 10 quantities.",
          },
          valueAsNumber: true,
        }}
      />
      <InputTextArea
        label={"description"}
        control={control}
        name="description"
        required
        placeholder="Describe more about line Item"
      />
    </div>
  );
}

const mapStateToProps = (state: RootState) => ({
  options: state?.warrntyItem?.options || {},
});

export default connect(mapStateToProps)(LineItem);
